module.exports = __webpack_public_path__ + "static/media/20240530085327_IMG_7476.1ea73062.JPG";